var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideOverlay),expression:"hideOverlay"}],class:[
    'navigation-wrapper',
    _vm.navIsCollapsed && 'is-collapsed',
    _vm.navIsOverlaid && 'is-overlaid',
    _vm.navIsOpen && 'is-open'
  ],on:{"mouseenter":_vm.showOverlay,"mouseleave":_vm.hideOverlay,"click":_vm.showOverlay}},[_c('div',{class:[
      'navigation',
      _vm.$store.getters.isUpmindContext &&
        !_vm.$store.getters['ui/isMobile'] &&
        'has-hazard-tape'
    ],style:({ height: _vm.dynamicHeight })},[_c('navigation-header'),_vm._v(" "),_c('navigation-body'),_vm._v(" "),_c('navigation-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }